import { CellContext, Row } from '@tanstack/react-table';
import { dateFormats, formatCurrency, formatDate, formatDuration } from '@instamenu/formatters';
import { DateTime, Duration } from 'luxon';

type ShiftDuration = number | 'Active';

export const columnHelpers = {
  currency: {
    meta: {
      renderCsv: (ctx: CellContext<any, number>) => formatCurrency(ctx.cell.getValue()),
      style: 'numeric',
    },
    cell: (ctx: CellContext<any, number>) => formatCurrency(ctx.cell.getValue()),
  },
  date: {
    meta: {
      renderCsv: (ctx: CellContext<any, DateTime | string | null | undefined>) =>
        formatDate(ctx.cell.getValue(), 'y-MM-dd TTT'),
    },
    cell: (ctx: CellContext<any, DateTime | string | null | undefined>) => {
      const val = ctx.cell.getValue();
      return formatDate(val, dateFormats.dateTimeShort, ctx.row.original?.restaurant?.timeZone);
    },
    sortingFn: 'basic' as const,
  },
  duration: (activeString: string) => ({
    meta: { style: 'numerical' },
    cell: (ctx: CellContext<any, ShiftDuration>) => {
      const value = ctx.cell.getValue();
      return value === 'Active' ? activeString : formatDuration(Duration.fromMillis(value));
    },
    sortingFn: (a: Row<any>, b: Row<any>) => {
      const aDuration =
        a.original.duration === 'Active' ? Number.POSITIVE_INFINITY : a.original.duration;
      const bDuration =
        b.original.duration === 'Active' ? Number.POSITIVE_INFINITY : b.original.duration;
      if (!aDuration || !bDuration) return 0;
      return aDuration === bDuration ? 0 : aDuration > bDuration ? 1 : -1;
    },
  }),
};
